var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"title title--line"},[_c('T',[_vm._v("Oeps er ging iets mis")])],1),_vm._v(" "),_c('router-link',{staticClass:"button button--ghost",attrs:{"to":{ name: 'documents'}}},[_c('i',{staticClass:"icon-chevron-left button--icon button__icon--left"}),_vm._v(" "),_c('T',[_vm._v("Terug naar documenten")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5d9d2d95","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/500.vue
// module id = 672
// module chunks = 0